/* eslint-disable no-unused-vars */
export const BASE_ON_PRICE = 'BASE_ON_PRICE'
export const SAVE_PLAN_DETAIL = 'SAVE_PLAN_DETAIL'
export const SAVE_CUSTOMER_PLAN = 'SAVE_CUSTOMER_PLAN'
export const CREATE_ORDER = 'CREATE_ORDER'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const IS_USE_COUPON = 'IS_USE_COUPON'
export const SAVE_POINT = 'SAVE_POINT'
export const IS_USE_BENEPO_POINT = 'IS_USE_BENEPO_POINT'
export const CANCEL_ORDER = 'CANCEL_ORDER'
export const SET_POINT = 'SET_POINT'
export const SCROLL_CALENDAR = 'SCROLL_CALENDAR'
export const CREATE_STAY_REQUEST = 'CREATE_STAY_REQUEST'

import {
  SET_BASE_ON_PRICE,
  SET_CUSTOMER_PLAN,
  SET_ORDER,
  SET_PLAN_DETAIL,
  SET_USE_COUPON,
  SET_CANCEL_ORDER,
  SET_USE_BENEPO_POINT,
  SET_SCROLL_CALENDAR
} from './mutations'

import OrderApi from '../../../apis/order'

export default {
  [SCROLL_CALENDAR]({ commit }, data) {
    commit(SET_SCROLL_CALENDAR, data)
  },
  [BASE_ON_PRICE]({ commit }, data) {
    commit(SET_BASE_ON_PRICE, data)
  },
  [SAVE_PLAN_DETAIL]({ commit }, data) {
    commit(SET_PLAN_DETAIL, data)
  },
  [SAVE_CUSTOMER_PLAN]({ commit }, data) {
    commit(SET_CUSTOMER_PLAN, data)
  },
  [CREATE_ORDER]({ commit }, data) {
    if (data.totalCost) {
      delete data.totalCost
    }
    const reserveId = data.reserveId
    const p = data.param
    if (data.param) {
      delete data.param
    }
    if (data.reserveId) {
      delete data.reserveId
    }
    return new Promise((resolve, reject) => { 
      OrderApi.createOrder(reserveId, p, data).then(
      (result) => {
        if (result && result.acptNo) {
          data['acptNo'] = result.acptNo
          data['acptDtlNo'] = result.acptDtlNo
          data['transactionId'] = result.transactionId
        }
        commit(SET_ORDER, data)
        resolve (result)
      },
      (error) => {
        reject (error)
      })
    })
  },
  [UPDATE_ORDER]({ commit }, data) {
    if (data.totalCost) {
      delete data.totalCost
    }
    const acptNo = data.acptNo
    const acptDtlNo = data.acptDtlNo
    const reserveId = data.reserveId
    if (data.param) {
      delete data.param
    }
    if (data.reserveId) {
      delete data.reserveId
    }
    if (data.acptNo) {
      delete data.acptNo
    }
    if (data.acptDtlNo) {
      delete data.acptDtlNo
    }
    if (data.transactionId) {
      delete data.transactionId
    }
    return OrderApi.updateOrder(acptNo, reserveId, data).then((result) => {
      if (result && result.acptNo) {
        data['acptNo'] = result.acptNo
        data['acptDtlNo'] = acptDtlNo
        data['transactionId'] = result.transactionId
      }
      commit(SET_ORDER, data)
    })
  },
  [IS_USE_COUPON]({ commit }, isUserCoupon) {
    commit(SET_USE_COUPON, isUserCoupon)
  },
  [IS_USE_BENEPO_POINT]({ commit }, isUseBenepoPoint) {
    commit(SET_USE_BENEPO_POINT, isUseBenepoPoint)
  },
  [SAVE_POINT]({ commit }, point) {
    commit(SET_POINT, point)
  },
  [CANCEL_ORDER]({ commit }, data) {
    const acptNo = data.acptNo
    if (data.acptNo) {
      delete data.acptNo
    }
    const p = data.param
    if (data.param) {
      delete data.param
    }
    return OrderApi.cancelOrder(acptNo, p, data)
  },
  [CREATE_STAY_REQUEST]({ commit }, data) {
    if (data.totalCost) {
      delete data.totalCost
    }
    const reserveId = data.reserveId
    const p = data.param
    if (data.param) {
      delete data.param
    }
    if (data.reserveId) {
      delete data.reserveId
    }
    return new Promise((resolve, reject) => { 
      OrderApi.createStayRequest(reserveId, p, data).then(
      (result) => {
        if (result && result.acptNo) {
          data['acptNo'] = result.acptNo
          data['acptDtlNo'] = result.acptDtlNo
          data['transactionId'] = result.transactionId
        }
        commit(SET_ORDER, data)
        resolve (result)
      },
      (error) => {
        reject (error)
      })
    })
  },
}
